/**
 * Configuración específica para la vista Forecast Metrics
 * Contiene constantes, mapeos y funciones de configuración
 */

// Mapeo de modelos a nombres de visualización
export const FORECAST_METRICS_MODEL_DISPLAY_NAMES = {
  "CNN_HISTORICAL:EU_025_live_demo": "Convection (~28km)",
  "CNN_HISTORICAL:EU_01_live_demo": "Convection (~9km)",
  "CNN_HISTORICAL:euro_1k_00625_15m": "Convection (~6km)",
};

// Mapeo de modelos a nombres de métricas
export const FORECAST_METRICS_NAMES = {
  "CNN_HISTORICAL:EU_025_live_demo": "METRICAS_CNN_025",
  "CNN_HISTORICAL:EU_01_live_demo": "METRICAS_CNN_01",
  "CNN_HISTORICAL:euro_1k_00625_15m": "METRICAS_CNN_00625",
};

// Valores por defecto para el estado
export const FORECAST_METRICS_DEFAULT_VALUES = {
  cqlSevere: 'Low',
  selectedModel: 'CNN_HISTORICAL:EU_025_live_demo',
  selectedRisk: 'Light',
  tabIndex: 0,
};

// Niveles de riesgo disponibles
export const FORECAST_RISK_LEVELS = ['Low', 'Light', 'Medium', 'High'];

/**
 * Obtiene la capa derecha basada en la capa izquierda seleccionada
 * @param {string} leftLayer - Capa izquierda seleccionada
 * @returns {string|null} - Capa derecha (ground truth) o null si el modelo no tiene (p.ej. turbulence → mapa único)
 */
export const getForecastRightLayer = (leftLayer) => {
  const layerMapping = {
    'CNN_HISTORICAL:EU_025_live_demo': 'TARGETS_CNN:lightnings_EU_025',
    'CNN_HISTORICAL:EU_01_live_demo': 'TARGETS_CNN:lightnings_EU_01',
    'CNN_HISTORICAL:euro_1k_00625_15m': 'TARGETS_CNN:lightnings_euro_1k_00625',
  };
  
  return layerMapping[leftLayer] || null;
};

/**
 * Obtiene el nombre bonito del modelo para mostrar
 * @param {string} modelKey - Clave del modelo
 * @returns {string} - Nombre de visualización del modelo
 */
export const getForecastModelDisplayName = (modelKey) => {
  return FORECAST_METRICS_MODEL_DISPLAY_NAMES[modelKey] || modelKey;
};

/**
 * Obtiene el nombre de las métricas para un modelo específico
 * @param {string} modelKey - Clave del modelo
 * @returns {string} - Nombre de las métricas
 */
export const getForecastMetricsName = (modelKey) => {
  return FORECAST_METRICS_NAMES[modelKey] || '';
};

// Configuración de la aplicación
export const FORECAST_METRICS_CONFIG = {
  API_URL: process.env.REACT_APP_API_URL,
  SLIDER_STEPS: 24,
  DEFAULT_ELEVATION: 2,
  LIVE_FORECAST_URL: 'https://weatherapp.aimethods.com/weather-map',
  KAIROS_URL: 'https://www.kairos-eu.com/',
};

// Configuración específica por capa
export const LAYER_SPECIFIC_CONFIG = {
  'CNN_HISTORICAL:euro_1k_00625_15m': {
    sliderSteps: 96, // 15 min intervalos en 24h = 96 pasos
    daysRange: [0], // Solo D-0
    hoursToGenerate: [0, 2, 4, 6, 8, 10, 12], // Horas específicas
    issueTimeOptions: [ // Opciones para el dropdown (si se usa) - Mantengo esto por compatibilidad con el plan original, aunque ahora usamos hoursToGenerate
      { label: '00:00', value: '00:00' },
      { label: '02:00', value: '02:00' },
      { label: '04:00', value: '04:00' },
      { label: '06:00', value: '06:00' },
      { label: '08:00', value: '08:00' },
      { label: '10:00', value: '10:00' },
      { label: '12:00', value: '12:00' },
    ]
  }
};
